export const defaultAgent = (agentArray) => {
  let defaultAgent = agentArray.find((agent) => agent.is_default === true);
  return defaultAgent;
};
